import { api } from 'src/services/api'

interface Response {
  pdfBase64: string
}

export async function getExtract(
  startDate: string,
  endDate: string,
  accountId: string,
  format: string
) {
  try {
    const token = localStorage.getItem('@backoffice:token')

    if (format === 'excel') {
      const response = await api.post<Blob>(
        '/extract/excel',
        {
          startDate,
          endDate,
          userId: accountId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      )

      const blob = response.data // O próprio Axios já retorna um Blob

      // Criar e acionar o link de download
      const downloadLink = document.createElement('a')
      const url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = 'extrato.xlsx'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(url)
    } else {
      const response = await api.post<Response>(
        '/extract',
        {
          startDate,
          endDate,
          userId: accountId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    }
  } catch (error) {
    console.error(error)
    throw new Error('Erro ao gerar o extrato.')
  }
}
